<template>
    <b-col col
           lg="9"
           cols="12"
           id="section_main"
           class="section-main">
        <futurocoins-from-mining></futurocoins-from-mining>
        <my-team-total></my-team-total>
        <my-team-tree></my-team-tree>
    </b-col>
</template>

<script>
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue'
    import MyTeamTotal from './my-team/MyTeamTotal.vue'
    import MyTeamTree from './my-team/MyTeamTree.vue'

    export default {
        components: { FuturocoinsFromMining, MyTeamTotal, MyTeamTree }
      }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/MyTeamContent.vue